import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import {
  attendeeCameraStatus,
  attendeeContentShareAudioProfile,
  attendeeDetails,
  attendeeMuteStatus,
  attendeeNetworkHealth,
  attendeePresence,
  attendeeReadinessCheck,
  attendeeReceivedFrame,
  attendeeRoster,
  attendeeVoiceIntensity,
  audioInputDevice,
  audioOutputDevice,
  backgrounds,
  banners,
  brandingSettings,
  broadcast,
  canStartStream,
  directorRequests,
  dragSource,
  featuredPresenter,
  isLoggedOut,
  isNotificationListActive,
  knocks,
  liveSources,
  mediaPlayerSettings,
  meeting,
  modal,
  notification,
  overlays,
  permissions,
  program,
  readinessCheck,
  sandboxMeetingSession,
  sandboxMeetingStatus,
  sceneLayers,
  sceneLayout,
  screenShareCount,
  serverTimeDelta,
  sessionState,
  settings as broadcastSettings,
  showReadinessCheck,
  sourceDisconnectTimeouts as broadcastSourceDisconnectTimeouts,
  sourceOnProgram,
  sources as broadcastSources,
  sourceUpdateStatus,
  stagedSources,
  startProgram,
  streamEndpoints,
  tabs,
  templates,
  trackableUserEvent,
  transformedVideoInputs,
  uploadStatus,
  uploadStatusVisibility,
  user,
  userBackground,
  videoDeviceLost,
  videoInputDevice
} from '@shoflo/studio-redux/reducers';
import { presenterSettingsSource } from '@shoflo/studio-redux/reducers/presenters';
import { team } from '@shoflo/studio-redux/reducers/team';
import { event } from '@shoflo/studio-redux/reducers/event';

function createRootReducer(history) {
  return combineReducers({
    router: connectRouter(history),
    modal,
    user,
    isLoggedOut,
    startProgram,
    broadcast,
    event,
    program,
    serverTimeDelta,
    mediaPlayerSettings,
    broadcastSettings,
    meeting,
    audioInputDevice,
    audioOutputDevice,
    videoInputDevice,
    banners,
    broadcastSources,
    sceneLayout,
    tabs,
    liveSources,
    attendeeCameraStatus,
    permissions,
    attendeeMuteStatus,
    featuredPresenter,
    knocks,
    streamEndpoints,
    screenShareCount,
    attendeeRoster,
    broadcastSourceDisconnectTimeouts,
    directorRequests,
    sceneLayers,
    backgrounds,
    attendeeNetworkHealth,
    attendeeReceivedFrame,
    isNotificationListActive,
    stagedSources,
    dragSource,
    templates,
    sessionState,
    notification,
    uploadStatusVisibility,
    uploadStatus,
    attendeeDetails,
    canStartStream,
    overlays,
    trackableUserEvent,
    sourceOnProgram,
    brandingSettings,
    sourceUpdateStatus,
    attendeeContentShareAudioProfile,
    readinessCheck,
    showReadinessCheck,
    sandboxMeetingStatus,
    sandboxMeetingSession,
    attendeePresence,
    videoDeviceLost,
    userBackground,
    attendeeReadinessCheck,
    attendeeVoiceIntensity,
    transformedVideoInputs,
    team,
    presenterSettingsSource
  });
}

export default createRootReducer;
